<div class="order-overflow-area">
  <h1 class="order-overflow-area__title">{{ 'ttw.orderOnOverflowArea' | translate }}</h1>
  <div class="order-overflow-area__section"></div>
  <button class="order-overflow-area__button" (click)="accept()">
    {{ 'ttw.acceptOverflowArea' | translate }}
  </button>
</div>
